import React from 'react';
import { Box, styled, Typography } from '@mui/material';
import BlogCard from './BlogPostCard';
import { BlogPostSummary } from '../../../../common/graphql/blogs/blogpost';
import Footer from '../../Footer/Footer';
import ContentHeader from '../../../../common/Styleguide/ContentHeader';

const BlogPostsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: theme.spacing(2.5),
  maxWidth: 1200,
}));

interface Props {
  blogs: BlogPostSummary[];
  blogLinkPrefix: string;
}

const BlogPosts: React.FC<Props> = ({ blogs, blogLinkPrefix }) => {
  return (
    <>
      <ContentHeader title="Blog" />
      <Box sx={{ padding: (theme) => theme.spacing(4) }}>
        {blogs.length === 0 && <Typography variant="h6">We don't have any blogposts published right now. Stay tuned!</Typography>}
        <BlogPostsContainer>
          {blogs.map((blog) => (
            <BlogCard blog={blog} key={blog.slug} blogLinkPrefix={blogLinkPrefix} />
          ))}
        </BlogPostsContainer>
        <Footer />
      </Box>
    </>
  );
};

export default BlogPosts;
